import React, { Component } from "react";
import { Col, Row, Card } from "reactstrap";
import CategoryIcon from "@mui/icons-material/Category";
import MinimizeIcon from "@mui/icons-material/Minimize";
import TreeView from "@material-ui/lab/TreeView";
import TreeItem from "@material-ui/lab/TreeItem";
import AddIcon from "@mui/icons-material/Add";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import PtsButton from "../buttons/PtsButton";
import store from "../../redux/store";
import FetchServerData from "../../provider/FetchServerData";
import { DialogActions } from "@material-ui/core";
import CodeUomListAction from "../../redux/codeUomList/CodeUomListAction";

class CatalogueDialog extends Component {
  header = store.getState().header.header;
  constructor(props) {
    super(props);
    this.state = {
      topCategories: [],
      catalogueId: "",
      childCategories: [],
      targetCategory: "",
      catalogueName: "",
      treeItemId: [],
      collapseTreeItem: [],
      checked: {},
      onChange: this.props.onChange,
      open: false,
    };
  }
  getCodeUomList() {
    const postObject = {
      header: this.header,
    };
    FetchServerData.callPostService("/assetms/getCodeUomList", postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          let assetCodeUomData = output.data;
          store.dispatch(CodeUomListAction.setCodeUomList(assetCodeUomData));
        } 
      }
    );
  }

  GetCatalogueWithSubcategorie() {
    const postObject = {
      header: this.header,
    };
    FetchServerData.callPostService(
      "/cataloguems/getFullCatalogue",
      postObject
    ).then((output) => {
      if (output.status === "SUCCESS") {
        let catalogueDetails = output.data.catalogue;
        let topCategories = output.data.topCategories;
        for (let i = 0; i < topCategories.length; i++) {
          topCategories[i].id = topCategories[i].id.toString();
        }
        this.getCodeUomList();
        this.setState({
          render: true,
          open: true,
          catalogueData: catalogueDetails,
          topCategories: topCategories,
          catalogueId: catalogueDetails.id,
          catalogueName: catalogueDetails.name,
        });
      }
    });
  }

  handleOpen() {
    this.setState({ open: true });
  }

  handleClose() {
    this.setState({ open: false });
  }

  handleSelectToggle = (event, nodeId) => {
    const index = this.state.treeItemId.indexOf(nodeId);
    const copyExpanded = [...this.state.treeItemId];
    if (index === -1) {
      copyExpanded.push(nodeId);
    } else {
      copyExpanded.splice(index, 1);
    }
    // setExpanded(copyExpanded);
    this.setState({
      treeItemId: copyExpanded,
    });
  };

  onSelectedChange = (event, selectedAsset) => {
    const { checked } = this.state;
    const checkedValues = { ...checked };
    checkedValues[event.target.name] = event.target.checked;
    this.setState((prevState, currState) => {
      return {
        ...prevState,
        checked: checkedValues,
        targetCategory: selectedAsset.id,
      };
    });
  };

  onSpanClick = (treeItemData) => {
    const id = String(treeItemData.id);
    const isChecked = this.state.checked[id] || false;

    this.setState((prevState) => ({
      checked: {
        ...prevState.checked,
        [id]: !isChecked, // toggle checkbox
      },
      targetCategory: treeItemData.id,
    }));
  };

  getTreeItemsFromData = (treeItems) => {
    return treeItems.map((treeItemData, index) => {
      let children = undefined;
      let isRoot = treeItemData.canAddAsset;
      if (
        treeItemData.childCategories &&
        treeItemData.childCategories.length > 0
      ) {
        children = this.getTreeItemsFromData(treeItemData.childCategories);
      }
      if (treeItemData.selected === true) {
        this.state.treeItemId.push(treeItemData.id.toString());
      }

      const { checked } = this.state;
      const checkedValues = { ...checked };
      const checkedCount = Object.values(checkedValues).filter(
        (value) => value
      ).length;
      return (
        <TreeItem
          key={treeItemData.id}
          nodeId={treeItemData.id.toString()}
          // label={treeItemData.name}
          label={
            <ul style={{ listStyle: "none" }} key={index}>
              <li
                style={{
                  padding: "0.5em",
                }}
              >
                <Row>
                  <Col>
                    <span
                      style={{
                        color: "black",
                        float: "left",
                        fontSize: "16px",
                      }}
                      onClick={() => this.onSpanClick(treeItemData)}
                    >
                      {treeItemData.name}
                    </span>
                    &nbsp;&nbsp;&nbsp;
                    {isRoot && (
                      <>
                        {parseInt(treeItemData.id) !== this.state.categoryId ? (
                          <input
                            type="checkbox"
                            id="topping"
                            key={index}
                            style={{ float: "left", margin: " 0.35em 0.5em" }}
                            name={treeItemData.id}
                            onChange={(e) =>
                              this.onSelectedChange(e, treeItemData)
                            }
                            value={treeItemData.id}
                            checked={
                              this.state.checked[treeItemData.id] || false
                            }
                            disabled={
                              !checkedValues[treeItemData.id] &&
                              checkedCount > 0
                            }
                          />
                        ) : (
                          ""
                        )}
                      </>
                    )}
                  </Col>
                </Row>
              </li>
            </ul>
          }
          children={children}
        />
      );
    });
  };

  handleToggle = (event, nodeIds) => {
    this.setState({
      treeItemId: nodeIds,
    });
  };

  toCreateAsset() {
    this.props.onChange(this.state.targetCategory, this.state.catalogueId);
  }

  render() {
    return (
      <Dialog
        open={this.state.open}
        onClose={this.handleClose.bind(this)}
        maxWidth="xl"
        className="categoryDialogue"
      >
        <DialogTitle
          id="scroll-dialog-title"
          style={{ backgroundColor: "#0B6F9D", padding: "8px 24px" }}
        >
          <span style={{ color: "#fff" }}>Choose Category</span>
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={this.handleClose.bind(this)}
          style={{
            position: "absolute",
            right: 8,
            top: 4,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon style={{ color: "#fff", fontWeight: "600" }} />
        </IconButton>
        <DialogContent>
          <div
            md={12}
            style={{
              width: "100%",
              color: "#000",
              fontSize: "small",
              padding: "0.5em",
            }}
          >
            <p style={{ fontSize: "13px", paddingBottom: "10px" }}>
              {`If you don’t see your category in the list, please create new
              category in ‘Catalogue->Add Category'`}
            </p>
            <Card
              style={{
                overflowY: "auto",
                overflowX: "hidden",
                padding: " 1em",
              }}
            >
              <Row>
                <Col
                  md={12}
                  className="toolBarCol"
                  style={{
                    textTransform: "capitalize",
                    margin: "0.5em auto auto auto",
                  }}
                >
                  <Row>
                    <Col>
                      <CategoryIcon
                        style={{
                          color: "#DC7633",
                          fontSize: "18px",
                          marginBottom: "3px",
                          float: "left",
                        }}
                      />
                      &nbsp; &nbsp;
                      <span
                        style={{
                          color: " #DC7633",
                          fontWeight: "bold",
                          float: "left",
                        }}
                      >
                        &nbsp;{this.state.catalogueName}
                      </span>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <TreeView
                        expanded={
                          this.state.treeItemId ? this.state.treeItemId : []
                        }
                        onNodeToggle={this.handleToggle}
                        onNodeSelect={this.handleSelectToggle}
                        collapsed={this.state.collapseTreeItem}
                        defaultCollapseIcon={
                          <MinimizeIcon
                            style={{
                              background: "gray",
                              color: "white",
                              paddingBottom: "0.4em",
                            }}
                          />
                        }
                        defaultExpandIcon={
                          <AddIcon
                            style={{ background: "gray", color: "white" }}
                          />
                        }
                      >
                        {this.getTreeItemsFromData(this.state.topCategories)}
                      </TreeView>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Card>
          </div>
        </DialogContent>
        <DialogActions>
          <div
            className="p-2"
            // style={{ padding: "1.2rem 1.5rem 1.5rem" }}
          >
            <PtsButton
              btnName="Create Asset"
              type="submit"
              onClick={this.toCreateAsset.bind(this)}
            />
            &nbsp;&nbsp;&nbsp;
            <button
              type="button"
              className="btn btn-label-secondary fw-bold"
              data-bs-dismiss="modal"
              style={{ background: "#8592a3", color: "#fff" }}
              onClick={this.handleClose.bind(this)}
            >
              Cancel
            </button>
          </div>
        </DialogActions>
      </Dialog>
    );
  }
}
export default CatalogueDialog;
